module.exports = __webpack_public_path__ + "img/info.3d868d3d.svg";